import { Anchor } from '@/components/ui/Anchor'
import { FileChip } from '@/components/ui/file-chip'
import { formatDate } from '@/lib/formatters'
import type { PolicyChangeAsk } from '@/models/policyChange'

/** Each question the broker asked, with the answer and files that came back. */
export function AskHistory({ asks, answerLabel }: { asks: PolicyChangeAsk[]; answerLabel: string }) {
  return (
    <div className="flex flex-col divide-y divide-neutral-100">
      {asks.map((ask) => (
        <div key={ask.id} className="flex flex-col gap-2 py-3 text-sm first:pt-0 last:pb-0">
          <div>
            <div className="text-xs text-neutral-500">Asked {formatDate(ask.askedAt)}</div>
            <p className="whitespace-pre-line text-neutral-900">{ask.question}</p>
          </div>
          {ask.answeredAt ? (
            <div className="border-l-2 border-neutral-200 pl-3">
              <div className="text-xs text-neutral-500">
                {answerLabel} {formatDate(ask.answeredAt)}
              </div>
              {ask.reply && <p className="whitespace-pre-line text-neutral-700">{ask.reply}</p>}
              {ask.files.length > 0 && (
                <ul className="mt-2 flex flex-wrap gap-2">
                  {ask.files.map((file) => (
                    <li key={file.id}>
                      {file.url ? (
                        <Anchor
                          href={file.url}
                          target="_blank"
                          rel="noreferrer"
                          aria-label={`Open ${file.name}`}
                        >
                          <FileChip name={file.name} className="hover:border-neutral-300" />
                        </Anchor>
                      ) : (
                        <FileChip name={file.name} />
                      )}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ) : (
            <div className="text-xs text-neutral-500">
              {ask.open ? 'Not answered yet' : 'Closed unanswered'}
            </div>
          )}
        </div>
      ))}
    </div>
  )
}
